import React from "react";
import PartyList from "./PartyList";

export default function SellerList() {
  return <PartyList type="seller" />;
}
